// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import SequenceNumberListPagingResultModel from '../../model/sequence-number-list-paging-result-model';
import SequenceNumberListPagingResultDTO from '../dto/sequence-number-list-paging-result-dto';
import dtoSchema from '../schemas/sequence-number-list-paging-result-schema';
import SequenceNumberListModel from '../../model/sequence-number-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class SequenceNumberListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<SequenceNumberListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => SequenceNumberListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: SequenceNumberListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<SequenceNumberListPagingResultDTO>): SequenceNumberListPagingResultModel;
  static toModel(dto: DeepPartial<SequenceNumberListPagingResultDTO> | undefined | null): SequenceNumberListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<SequenceNumberListPagingResultDTO> | undefined | null): SequenceNumberListPagingResultModel | undefined {
    return dto ? new SequenceNumberListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<SequenceNumberListPagingResultModel> | SequenceNumberListPagingResultModel): SequenceNumberListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as SequenceNumberListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for SequenceNumberListPagingResultModel, can not map to SequenceNumberListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
